package com.parmartechnologies.core.constant

enum class Protocol(val value: String) {
    HTTP("http"),
    HTTPS("https"),
    WS("ws")
}

class AppServer {
    init {
        instance = this
    }

    companion object {
        var mode = Environment.dev
        var currentDomain = ""
        var currentProtocol = ""
        var activeServer = ""
        private var instance: AppServer? = null
        fun shared(): AppServer {
            return if (instance != null) {
                instance as AppServer
            } else {
                instance = AppServer()
                instance as AppServer
            }
        }
    }


    private var primarySocketServer: String =
        "https://friendly-prod-377179729932.asia-south1.run.app"
    val prodDomain = "friendly-prod-377179729932.asia-south1.run.app"
    val qaDomain = "friendly-qa-377179729932.asia-south1.run.app"


    //    fun getRestApiEndPointFor(api: String): String {
//        return "$localServer/$api"
//        return "$primaryServer/$api"
//    }
    fun getFriendlyProdServer(): String {
        return primarySocketServer
    }

    var activeServerAddress = ""
    var activeSocketServer = ""
    var localIp = ""
    fun getRestApiEndPointFor(api: String, name: String): String {
        return "$activeServerAddress$api$name"
    }

    fun getRestApiEndPointFor(path: String): String {
        return "$primarySocketServer/$path"
    }

    fun getAuthRestApiEndPointFor(api: String, name: String): String {
        return "${currentProtocol}://$currentDomain/$api$name"
    }

    fun getSocketEndpoint(): String{
        return activeSocketServer
    }

    fun setup(environment: Environment) {
        mode = environment
        if (environment == Environment.dev) {
            activeServerAddress = "${Protocol.HTTP.value}://$localIp:8080"
            activeSocketServer = "${Protocol.WS.value}://$localIp:8080"
        } else if (environment == Environment.qa) {
            activeServerAddress = "${Protocol.HTTPS.value}://$qaDomain:8080"
            activeSocketServer = "${Protocol.WS.value}://$qaDomain/ws"
        } else {
            activeServerAddress = "${Protocol.HTTPS.value}://$prodDomain"
            activeSocketServer = "${Protocol.WS.value}://$prodDomain/ws"
        }
    }

    fun setup(ip: String) {
        mode = Environment.dev
        localIp = ip
        activeServerAddress = "${Protocol.HTTP.value}://$ip:8080"
    }

    fun setupFor(url: String) {
        mode = Environment.dev
        activeServerAddress = url
    }

}




